import { SpriteItem } from './types'

export const spriteData: SpriteItem[] = [
  {
    class: 'palms-l',
    x: 2111,
    y: 889,
    w: 734,
    h: 972,
    speed: 1,
    dx: -50,
    dy: 0,
    position: {
      bottom: -54,
      left: -65,
    },
    mobilePosition: {
      bottom: 71,
      left: -135,
    },
  },
  {
    class: 'palms-r',
    x: 1171,
    y: 1963,
    w: 457,
    h: 876,
    speed: 3,
    dx: 50,
    dy: 0,
    position: {
      bottom: 16,
      right: -30,
    },
    mobilePosition: {
      bottom: 38,
      right: -37,
    },
  },
  {
    class: 'boss',
    x: 1,
    y: 1,
    w: 369,
    h: 522,
    speed: 1,
    dx: -40,
    dy: 0,
    position: {
      bottom: -33,
      left: 380,
    },
    mobilePosition: {
      bottom: 30,
      left: 96,
    },
  },
  {
    class: 'bull',
    x: 1434,
    y: 651,
    w: 671,
    h: 689,
    speed: 1,
    axis: 'xy',
    dx: -50,
    dy: 50,
    position: {
      bottom: -93,
      left: -50,
    },
    mobilePosition: {
      bottom: -129,
      left: -112,
    },
  },
  {
    class: 'mummy',
    x: 315,
    y: 989,
    w: 849,
    h: 1248,
    speed: 2,
    axis: 'x',
    dx: -40,
    dy: 10,
    position: {
      bottom: -277,
      left: -165,
    },
    mobilePosition: {
      bottom: -240,
      left: -156,
    },
  },
  {
    class: 'brushes-l',
    x: 372,
    y: 1,
    w: 1055,
    h: 453,
    speed: 1.5,
    axis: 'x',
    dx: -15,
    dy: 0,
    position: {
      bottom: -8,
      left: -20,
    },
    mobilePosition: {
      bottom: 0,
      left: 0,
    },
  },
  {
    class: 'fishman',
    x: 2112,
    y: 1,
    w: 880,
    h: 789,
    speed: 3,
    dx: 40,
    dy: 10,
    position: {
      bottom: 4,
      right: -61,
    },
    mobilePosition: {
      bottom: -10,
      right: -70,
    },
  },
  {
    class: 'guss',
    x: 1,
    y: 989,
    w: 317,
    h: 586,
    speed: 1,
    dx: 25,
    dy: 20,
    position: {
      bottom: -100,
      right: 480,
    },
    mobilePosition: {
      bottom: -35,
      right: 60,
    },
  },
  {
    class: 'brushes-r',
    x: 372,
    y: 456,
    w: 865,
    h: 453,
    speed: 1,
    dx: 10,
    dy: 0,
    position: {
      bottom: -10,
      right: -19,
    },
    mobilePosition: {
      bottom: 0,
      right: -64,
    },
  },
]
